<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px" class="unitWidth" size="small"> </el-form>
        </SearchBox>
        <LabelContent :title="$t('EnumType.EnumType')" ref="LabelContent">
            <div slot="btns">
                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()">{{$t('base.add')}}</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <el-table-column prop="etName" :label="$t('base.name')" />
                <el-table-column prop="etCode" :label="$t('EnumType.code')" />
                <el-table-column prop="enumType" :label="$t('EnumType.type')">
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.row.enumType == 'dev_file'">{{$t('EnumType.DeviceFiles')}}</span>
                        <span v-if="scope.row.enumType == 'tool_status'">{{$t('EnumType.ToolStatus')}}</span> -->
                        <span v-if="scope.row.enumType == 'dev_file'">设备文件</span>
                        <span v-if="scope.row.enumType == 'tool_status'">工装状态</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isActive" :label="$t('base.ifEnable')">
                    <template slot-scope="scope">
                        <!-- <span>{{ scope.row.isActive ? $t('User.Yes'):$t('User.No') }}</span> -->
                        <span>{{ scope.row.isActive ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="130">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center; justify-content: center">
                            <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="500px" :visible.sync="updateShow" style="text-align: left">
            <div style="display: flex; justify-content: center">
                <el-form :model="enumTypeForm" :rules="enumType" ref="enumType" label-width="60px" class="demo-roleForm">
                    <el-form-item :label="$t('base.name')" prop="etName">
                        <el-input v-model="enumTypeForm.etName" :placeholder="$t('base.PleaseEnter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('EnumType.code')" prop="etCode">
                        <el-input v-model="enumTypeForm.etCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('EnumType.type')" prop="enumType">
                        <el-select v-model="enumTypeForm.enumType" :placeholder="$t('base.PleaseSelect')">
                            <el-option :label="$t('EnumType.DeviceFiles')" value="dev_file"></el-option>
                            <el-option :label="$t('EnumType.ToolStatus')" value="tool_status"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('User.state')">
                        <el-switch v-model="enumTypeForm.isActive" :active-text="$t('User.Yes')" :inactive-text="$t('User.No')"></el-switch>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updateFileType('enumType')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'fileType',
  data () {
    return {
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      tableData: [],
      ifAdd: false,
      updateShow: false,
      enumTypeForm: {
        etCode: '',
        etName: '',
        enumType: '',
        isActive: ''
      },
      enumType: {
        etCode: [
          {
            required: true,
            message: this.$t('base.PleaseEnter'),
            trigger: 'blur'
          }
        ],
        etName: [
          {
            required: true,
            message: this.$t('base.PleaseEnter'),
            trigger: 'blur'
          }
        ],
        enumType: [
          {
            required: true,
            message: this.$t('base.PleaseSelect'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted () {
    this.searchTable()
  },
  methods: {
    updatehOpen (row) {
      if (this.ifAdd) {
        this.enumTypeForm = {}
        this.updateShow = true
      } else {
        this.enumTypeForm = JSON.parse(JSON.stringify(row))
        this.updateShow = true
      }
    },
    updateFileType (enumType) {
      if (this.ifAdd) {
        this.$refs[enumType].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              url: this.$api.addEnumType,
              data: this.enumTypeForm
            }
            var self = this
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                self.$message.success(this.$t('base.SuccessfullyAdded'))
                self.searchTable()
                self.updateShow = false
              } else {
                self.$message.error(response.message)
                self.updateShow = false
              }
            })
          } else {
            return false
          }
        })
      } else {
        this.$refs[enumType].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              url: this.$api.editEnumType,
              data: this.enumTypeForm
            }
            var self = this
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                self.$message.success(this.$t('base.SuccessfullyUpdated'))
                self.searchTable()
                self.updateShow = false
              } else {
                self.$message.error(response.message)
                self.updateShow = false
              }
            })
          } else {
            return false
          }
        })
      }
    },
    deleteRow (row) {
      this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
        confirmButtonText: this.$t('base.delete'),
        cancelButtonText: this.$t('base.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$http
            .request({
              method: 'POST',
              params: {
                etId: row.etId
              },
              url: this.$api.delEnumType
            })
            .then(response => {
              this.searchTable()
              // this.$message.success(response.message);
            })
            .catch(err => {
              this.searchTable()
              // this.$message.error(err);
            })
        })
        .catch(() => {
          this.searchTable()
          this.$message({
            type: 'info',
            message: this.$t('msg.cancel')
          })
        })
    },
    paginationChange (val) {
      this.searchParams.pageSize = val
      this.searchTable()
    },
    paginationCurrentChange (val) {
      this.searchParams.page = val
      this.searchTable()
    },
    searchTable () {
      let queryParams = {
        pageSize: this.searchParams.pageSize,
        pageNum: this.searchParams.page
      }
      let options = {
        method: 'GET',
        params: queryParams,
        url: this.$api.enumTypePageList
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.tableData = response.data.list
          this.searchParams.pageCount = response.data.total
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
